import React from "react";
import "./Footer.css"


function Footer(){
    return <>
        <div id="footer">
            <div id="footer-content">
                <div id="footer-links">
                    <a href="/tos">Terms of Service</a>
                    <a href="/privacy">Privacy Policy</a>
                </div>
                <div id="footer-text">
                    © 2025 VeilStream, Inc. All rights reserved.
                </div>
            </div>
        </div>
    </>
}

export default Footer